import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-edit-title-dialog',
  templateUrl: './edit-title-dialog.component.html',
  styleUrls: ['./edit-title-dialog.component.scss']
})
export class EditTitleDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<EditTitleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      name: string,
      id: number
    }) {}

  ngOnInit(): void {
  }

  onDismiss() {
    this.dialogRef.close();
  }

}
